import { ACTIONS } from "UTILS/Constants";

export const addMessage = messageDetails => {
  return {
    type: ACTIONS.CHAT.ADD_MESSAGE,
    messageDetails: messageDetails
  };
};

export const displayMessage = messageDisplay => {
  return {
    type: ACTIONS.CHAT.DISPLAY_MESSAGE,
    messageDisplay: messageDisplay
  };
};

export const setMessagesRead = value => {
  return {
    type: ACTIONS.CHAT.SET_MESSAGES_READ,
    value: value
  };
};

export const showMessageArrivedToastAction = value => {
  return {
    type: ACTIONS.CHAT.MESSAGE_ARRIVED,
    value: value
  };
};
